import React, { useEffect, useState, useRef } from 'react';
import { Form, Modal, Spinner, ButtonGroup, InputGroup, ToggleButton } from 'react-bootstrap';
import { Button, Card, CardBody, Row, Col, Label, Input } from 'reactstrap';
import Axios from 'axios';
import { useHistory } from 'react-router-dom';
import { Backspace, Images, Save2Fill, Trash, Upload } from 'react-bootstrap-icons';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import * as Yup from 'yup';
import { Formik } from 'formik';

import common from '../../../commonData';
import dateformat from 'dateformat';
import Table from 'views/tableaddedit';
import readXlsxFile from 'read-excel-file';
import FormTable from './gridtableForm';

var count = 0;

function ReglementForm({
    id,
    setShowAdd,
    show,
    setIsSave,
    setDatas,
    setMsg,
    setMsgravity,
    stateParent,
    setActualise,
    actualise,
    EditreglementData
}) {
    // console.log(EditreglementData);
    var ladate = new Date();
    const [codeart, setCodeart] = useState([]);
    const [facturenonsolde, setFacturenonsolde] = useState([]);
    const [clients, setClientData] = useState([]);
    const [canal_payement, setListeCanal] = useState([]);
    const [listeSelect, setListeSelect] = useState(groupByRegelement(EditreglementData?.lignereglement) || []);
    const [load, setLoad] = useState(false);
    const [totalMontantImpute, setTotalImpute] = useState(0);
    const [type, setType] = useState(EditreglementData?.type_reglement || 'Espèce');
    const history = useHistory();
    const fourn = useRef(null);
    const [states, setState] = useState({
        date_regl:
            dateformat(EditreglementData?.date_regl, 'yyyy-mm-dd') ||
            dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
        montant: EditreglementData?.montant || 0,
        client_id: EditreglementData?.client_id,
        norecu: EditreglementData?.norecu || '',
        nocheq: EditreglementData?.nocheq || '',
        canale_payement: EditreglementData?.canale_payement || '1'
    });
    const { date_regl, montant, client_id, nocheq, norecu, canale_payement } = states;
    useEffect(() => {
        if (!localStorage.getItem('user-info')) {
            history.push('/login');
        }
        (async function anyNameFunction() {
            setLoad(true);
            const facturenonsolde = Axios.get(common.ipapi + '/api/facture-client/facturenonsolde/' + common.societe);
            const getFourn = Axios.get(common.ipapi + '/api/client/indexmin');
            const canal = Axios.get(common.ipapi + '/api/canal-paiement');
            await Axios.all([facturenonsolde, getFourn, canal])
                .then(
                    Axios.spread((...responses) => {
                        setFacturenonsolde(responses[0].data.datas);
                        if (EditreglementData?.lignereglement && EditreglementData?.lignereglement.length > 0) {
                            setFacturenonsolde(responses[0].data.datas);
                        } else {
                            setListeSelect(responses[0].data.datas);
                        }
                        setClientData(responses[1].data);
                        setListeCanal(responses[2].data.datas);
                        setLoad(false);
                    })
                )
                .catch((errors) => {
                    setLoad(false);
                });
        })();
    }, []);

    function groupByRegelement(tableauObjets) {
        let t = [];
        if (!tableauObjets) return t;
        tableauObjets.forEach((element) => {
            t.push({
                facture_id: element.id,
                nofact: element.nofact,
                datefact: element.datefact,
                user_id: element.user_id,
                client_id: element.client_id,
                created_at: element.created_at,
                updated_at: element.updated_at,
                user_update: element.user_update,
                societe: element.societe,
                montantfacture: element.montantfacture[2],
                montantreglemnt: element.montantreglemnt, // + element.pivot.montant,
                montant_impute: element.pivot.montant,
                idligne: element.pivot.id
            });
        });
        return t;
    }
    function saveEntree(values, setSubmitting) {
        try {
            if (facturenonsolde.length == 0) {
                setMsg('Veuillez sélectionner les produits');
                setMsgravity('danger');
                setIsSave(true);
                return;
            }
            if (values.montant <= 0) {
                setMsg('Le montant doit être supérieur à 0');
            }
            if (values.client_id == 0) {
                setMsg('Veuillez sélectionner un client');
                setMsgravity('danger');
                setIsSave(true);
                return;
            }
            if (values.montant < totalMontantImpute) {
                setMsg('Le montant du règlement est inférieur au total imputé');
                setMsgravity('danger');
                setIsSave(true);
                return;
            }

            setLoad(true);
            setSubmitting(true);
            var formData = new FormData();
            formData.append('date_regl', values.date_regl);
            formData.append('montant', values.montant);
            formData.append('client_id', values.client_id);
            formData.append('listeSelect', JSON.stringify(listeSelect));
            formData.append('type_reglement', type);
            formData.append('nocheq', values.nocheq);
            formData.append('norecu', values.norecu);
            formData.append('user_id', common.userid);
            formData.append('societe', common.societe);
            formData.append('canale_payement', values.canale_payement);
            Axios({
                url: EditreglementData?.id
                    ? common.ipapi + '/api/reglement/update/' + EditreglementData?.id
                    : common.ipapi + '/api/reglement/store',
                method: 'POST',
                headers: {
                    'Content-Type': 'form-data'
                },
                data: formData
            })
                .then((res) => {
                    if (res.status !== 200) {
                        setMsg('Veuillez vérifier votre connexion internet');
                        setMsgravity('info');
                        setIsSave(false);
                        setLoad(false);
                        setSubmitting(false);
                        return;
                    }
                    if (res.data.status === 1) {
                        setCodeart([]);
                        fourn.current.clear();
                        setMsg(res.data.msg);
                        setIsSave(true);
                        setMsgravity('info');
                        setFacturenonsolde([]);
                        count++;
                        setActualise(!actualise);
                        setLoad(false);
                        setSubmitting(false);
                        setTimeout(handleClose, 600);
                    } else {
                        setMsgravity('warning');
                        setIsSave(true);
                        if (res.data.msg == 23000) {
                            setMsg('Veuillez remplir tous les champs');
                        } else {
                            setMsg(res.data.msg);
                        }
                        setLoad(false);
                        setSubmitting(false);
                    }
                })
                .catch((error) => {
                    setMsg('Une erreur à eu lieu lors de la création');
                    setIsSave(false);
                    setMsgravity('danger');
                    setLoad(false);
                    setSubmitting(false);
                });
        } catch (error) {
            setMsg('Veuillez vérifier votre connexion internet');
            setIsSave(true);
            setMsgravity('danger');
            setLoad(false);
            setSubmitting(false);
        }
    }

    const handleClose = () => {
        count = 0;
        setShowAdd(false);
        setIsSave(false);
    };

    return (
        <>
            <Modal show={load} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    Veuillez patienter.......
                    <Spinner animation="grow" variant="warning" />
                </Modal.Body>
            </Modal>

            <Formik
                initialValues={{
                    montant: montant,
                    date_regl:
                        date_regl || dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
                    client_id: client_id,
                    norecu: norecu,
                    nocheq: nocheq,
                    canale_payement: canale_payement,
                    user_id: common.userid
                }}
                // enableReinitialize
                validationSchema={Yup.object().shape({
                    client_id: Yup.number().required(common.msg),
                    date_regl: Yup.date().required(common.msg)
                })}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        saveEntree(values, setSubmitting);
                    } catch (err) {
                        setMsg('Une erreur à eu lieu');
                        setMsgravity('danger');
                        setIsSave(true);
                        setLoad(false);
                    }
                }}
            >
                {({ handleBlur, handleChange, handleSubmit, isSubmitting, values, setFieldValue, setFieldTouched }) => (
                    <Modal show={show} fullscreen={true} onHide={handleClose}>
                        <Form noValidate onSubmit={handleSubmit}>
                            <Modal.Header>
                                {EditreglementData?.id ? 'MODIFICATION REGLEMENT CLIENT' : 'FAIRE UN REGLEMENT CLIENT'}
                                <Backspace onClick={handleClose} color="red" size={30} />
                            </Modal.Header>
                            <Modal.Body>
                                <div id="lightbody">
                                    <Row>
                                        <Col md={4}>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    Client:
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Typeahead
                                                        id="client_id"
                                                        ref={fourn}
                                                        multiple={false}
                                                        onChange={(selected) => {
                                                            const value = selected.length > 0 ? selected[0].id : 0;
                                                            setFieldValue('client_id', value);
                                                            setListeSelect(facturenonsolde.filter((fact) => fact.client_id === value));
                                                        }}
                                                        onInputChange={(text, event) => setFieldValue('client_id', text)}
                                                        onBlur={(e) => setFieldTouched('client_id', true)}
                                                        labelKey="raisonsocial"
                                                        options={clients}
                                                        selected={clients.slice(
                                                            clients.findIndex((element) => element.id === values.client_id),
                                                            clients.findIndex((element) => element.id === values.client_id) + 1
                                                        )}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    Date règlement:
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        id="date_regl"
                                                        type="date"
                                                        placeholder="Date règlement"
                                                        aria-describedby="inputGroupPrepend"
                                                        required
                                                        size="sm"
                                                        value={values.date_regl}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    Montant règlement:
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        id="montant"
                                                        type="number"
                                                        placeholder="Montant règlement"
                                                        aria-describedby="inputGroupPrepend"
                                                        required
                                                        size="sm"
                                                        value={values.montant}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        // onBlur={(e) => {
                                                        //     console.log(e.target.value);
                                                        //     setFieldValue('number', e.target.value);
                                                        // }}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    N° de reçu
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="N° de reçu"
                                                        aria-describedby="inputGroupPrepend"
                                                        size="sm"
                                                        id="norecu"
                                                        value={values.norecu}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Veuillez saisir le code article
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    Canal de paiement:
                                                    {/* <Star color="red" size={10} /> */}
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Input
                                                        id="canale_payement"
                                                        type="select"
                                                        aria-label="Canal de paiement"
                                                        value={values.canale_payement}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        size="small"
                                                    >
                                                        {canal_payement.map((d, index) => {
                                                            return (
                                                                <option key={index} value={d.id}>
                                                                    {d.lib_canal}
                                                                </option>
                                                            );
                                                        })}
                                                    </Input>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Col} md="12" controlId="revision">
                                                <InputGroup hasValidation>
                                                    <ButtonGroup>
                                                        {[
                                                            { name: 'Espèce', value: 'Espèce' },
                                                            { name: 'Chèque', value: 'Chèque' },
                                                            { name: 'Virement', value: 'Virement' }
                                                        ].map((radio, idx) => (
                                                            <ToggleButton
                                                                key={idx}
                                                                id={`radiorevision-${idx}`}
                                                                type="radio"
                                                                size="sm"
                                                                variant={idx % 2 ? 'outline-warning' : 'outline-warning'}
                                                                value={radio.value}
                                                                checked={type === radio.value}
                                                                onChange={(e) => setType(e.currentTarget.value)}
                                                            >
                                                                {radio.name}
                                                            </ToggleButton>
                                                        ))}
                                                    </ButtonGroup>
                                                    <Form.Control.Feedback type="invalid">
                                                        Veuillez selectionnez la revision.
                                                    </Form.Control.Feedback>
                                                </InputGroup>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    N° chèque/virement
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="N° chèque/virement"
                                                        aria-describedby="inputGroupPrepend"
                                                        size="sm"
                                                        id="nocheq"
                                                        value={values.nocheq}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Veuillez saisir le code article
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                        <Col md={8}>
                                            <Card>
                                                <CardBody>
                                                    <Row>
                                                        <Col md={12}>
                                                            <FormTable
                                                                data={listeSelect}
                                                                setListeSelect={setListeSelect}
                                                                setTotalImpute={setTotalImpute}
                                                                totalMontantImpute={totalMontantImpute}
                                                                idreglement={EditreglementData?.id}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <div className="ml-auto">
                                    <ButtonGroup size="sm">
                                        <Button color="danger" onClick={handleClose}>
                                            <Backspace color="#000" size={20} />
                                        </Button>
                                        <Button type="submit" variant="ligth" disabled={isSubmitting}>
                                            {isSubmitting ? (
                                                <Spinner animation="border" variant="success" />
                                            ) : (
                                                <Save2Fill color="#807f7e" size={20} />
                                            )}{' '}
                                            Enregister
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                )}
            </Formik>
        </>
    );
}

export default ReglementForm;
